import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { BarcodeFormat } from "@zxing/library";
import { finalize, take } from "rxjs/operators";
import * as moment from "moment";

@Component({
  selector: "app-admin-qr-reader",
  templateUrl: "./admin-qr-reader.component.html",
  styleUrls: ["./admin-qr-reader.component.scss"],
})
export class AdminQrReaderComponent implements OnInit {
  allowedFormats = [BarcodeFormat.QR_CODE];
  modalVisible = false;
  verifyResultList = [];
  loading = false;
  qrData = "";

  constructor(private http: HttpClient) {}

  ngOnInit(): void {}

  onScanSuccess(result: string) {
    this.modalVisible = false;
    this.loading = true;
    this.qrData = result;
    this.http
      .post("/verifyDiscountCodeWithQr", {
        qrData: this.qrData,
      })
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe((res: any) => {
        if (res.error || !res.length) {
          alert(res.message || "QR kodu geçersiz");
        } else {
          this.verifyResultList = res;
          for (const item of this.verifyResultList) {
            if (this.canUseDiscount(item)) {
              this.toggleDiscountState(item, "USED");
            }
          }
        }
      });
  }

  canUseDiscount(item) {
    if (item.hasSameSurvey || item.hasSameSurveyAndItHasBeenUsed) {
      return false;
    }

    if (item.discountState === "NOT_USED") {
      const diff = moment(item.campaignExpireDate).diff(moment(), "d");
      return diff >= 0;
    }

    return false;
  }

  toggleDiscountState(item, newDiscountState: string) {
    this.http
      .post("/toggleDiscountState", {
        _id: item._id,
        newDiscountState,
      })
      .pipe(take(1))
      .subscribe(() => {});
  }
}
